/** Soccer: FIFA Club World Cup League IDs */
export const fifaCwcLeagueIds = [
	159483, 159484, 161348, 161576, 161577, 161578, 161579, 161580, 161581,
	161582, 161583, 161604, 161605, 161606, 161607, 161608, 161609, 161610,
	161611, 161612, 161613, 161614, 161615, 161616, 161617, 161618, 161619,
	161620, 161621, 161622, 161623, 161624, 161625, 161626, 161627, 161628,
	161629, 161630, 161631, 161632, 161633, 161634, 161635, 161636, 161637,
	161638, 161639, 161640, 161641, 161642, 161643, 161644, 161645, 161646,
	161647, 161663, 161664, 161665, 161666, 161667, 161668, 161669, 161670,
	163143, 163524, 163525, 163526, 163527, 163528, 163529, 163530, 163531,
	164203, 164205, 164831, 164832, 164833, 164834, 164835, 164836, 164837,
	164838, 164839, 164840, 164841, 164842, 164843, 164844, 164845, 164846,
	165318, 165319, 165320, 165321, 165322, 165323, 165324, 165325, 165326,
	165395, 165697, 165698, 165699, 165700, 165701, 165702, 165703, 165756,
	166060, 166061, 166062, 166124, 166141, 166142, 166143, 166144, 166145,
	166146, 166147, 166148, 166149, 166194, 166195, 166196, 166282, 166283,
	166284, 166285, 166286, 166287, 166553, 166634, 166635, 166636, 166637,
	166638, 166639, 166640, 166641, 166642, 166952, 166953, 166954, 166955,
	166956, 166957, 166978, 166979, 166982, 166983, 167080, 167081, 167106,
	167136, 167137, 167157, 167186, 167223, 167290, 167340
];